import type { HTMLAttributes, ReactNode } from "react";
import styles from "./Card.module.css";

interface CardProps extends HTMLAttributes<HTMLDivElement> {
  children: ReactNode;
  /** Adds hover / press states + cursor pointer. */
  pressable?: boolean;
  /** Padding inside the card. Default 20px. Pass 0 for edge-to-edge tables. */
  padding?: number | string;
  className?: string;
}

/**
 * Card — the base surface primitive. `--surface`, hairline, `--radius-card`.
 *
 * The card does not compose its own header/body/footer. Sub-sections
 * are the caller's responsibility because every card in this product
 * has different anatomy.
 */
export function Card({
  children,
  pressable,
  padding = 20,
  className,
  style,
  ...rest
}: CardProps) {
  const classes = [styles.card, pressable ? styles.pressable : null, className]
    .filter(Boolean)
    .join(" ");
  return (
    <div
      {...rest}
      className={classes}
      style={{ padding, ...style }}
    >
      {children}
    </div>
  );
}
